import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getAccounting } from './accounting.selectors';

export const getAccountingClasses = createSelector(getAccounting, ({ classes }) => classes);

export const getAccountingClassById = memoizeOne(id =>
  createSelector(getAccountingClasses, classes => classes?.find(item => id && item.id === id)),
);
